import { render, staticRenderFns } from "./WidgetCurrentUsage.vue?vue&type=template&id=3178123e&scoped=true&"
import script from "./WidgetCurrentUsage.vue?vue&type=script&lang=js&"
export * from "./WidgetCurrentUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178123e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3178123e')) {
      api.createRecord('3178123e', component.options)
    } else {
      api.reload('3178123e', component.options)
    }
    module.hot.accept("./WidgetCurrentUsage.vue?vue&type=template&id=3178123e&scoped=true&", function () {
      api.rerender('3178123e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/widgetcurrentusage/WidgetCurrentUsage.vue"
export default component.exports